import { useState } from "react";
import { DashboardChart } from "@/components/dashboard/DashboardChart";
import { DashboardHero } from "@/components/dashboard/DashboardHero";
import { FruitCards } from "@/components/dashboard/FruitCards";
import { ReminderBanner } from "@/components/reminders/ReminderBanner";
import { StatsSummary } from "@/components/dashboard/StatsSummary";
import { useDashboardData } from "@/hooks/useDashboardData";
import { useReminderBanner } from "@/hooks/useReminderBanner";

export const Dashboard = () => {
  const [period, setPeriod] = useState("all");
  const { chartData, error, loading, summary } = useDashboardData(period);
  const reminderStatus = useReminderBanner();

  return (
    <main className="devotional-shell min-h-screen px-4 py-8 sm:px-6 lg:px-8" data-testid="dashboard-page">
      <div className="mx-auto max-w-7xl space-y-8">
        <DashboardHero />
        <ReminderBanner status={reminderStatus} />
        <StatsSummary loading={loading} overallAverage={summary?.overall_average} period={period} onPeriodChange={setPeriod} />

        {error && (
          <section className="rounded-2xl border border-[#E5E1D8] bg-white p-5 text-[#A85F4B] shadow-[0_8px_30px_rgba(26,54,38,0.04)]" data-testid="dashboard-error-message">
            {error}
          </section>
        )}

        <FruitCards trends={summary?.fruit_trends} />
        <DashboardChart chartData={chartData} />
      </div>
    </main>
  );
};